import { ApprovalTypes } from '../../utils/constants'
import { defaultAddressValues, testAddressValues } from '../Address'
import { defaultBusinessHours, testBusinessHours } from '../DailyBusinessHours'
import { OnboardingDevice } from './OnboardingDevice'
import { OnboardingLocation } from './OnboardingLocation'

export interface OnboardingState {
  id?: number
  location: OnboardingLocation
  isStripeOnboardingComplete: boolean
  isComplete: boolean
  stripeConnectId: string | null
  device?: OnboardingDevice
  organizationId: number | null
}

export const defaultOnboardingState: OnboardingState = {
  stripeConnectId: process.env.REACT_APP_TEST_STRIPE_CONNECT_ID ?? '',
  location: {
    name: defaultAddressValues.name,
    imageUrls: [],
    address: defaultAddressValues.streetAddress,
    city: defaultAddressValues.city,
    state: defaultAddressValues.state,
    zipCode: defaultAddressValues.zipCode,
    organizationId: 0,
    businessHours: defaultBusinessHours,
  },
  isComplete: false,
  isStripeOnboardingComplete: false,
  organizationId: null,
}

export const testOnboardingState: OnboardingState = {
  id: 2,
  stripeConnectId: process.env.REACT_APP_TEST_STRIPE_CONNECT_ID ?? '',
  location: {
    imageUrls: [
      'https://images.pexels.com/photos/65438/pexels-photo-65438.jpeg?auto=compress&cs=tinysrgb&w=800',
    ],
    address: testAddressValues.streetAddress,
    city: testAddressValues.city,
    state: testAddressValues.state,
    zipCode: testAddressValues.zipCode,
    latitude: testAddressValues.latitude,
    longitude: testAddressValues.longitude,
    businessHours: testBusinessHours,
  },
  device: {
    name: 'Main TV',
    screenSize: 24,
    monthlyPrice: 30,
    imageUrl:
      'https://images.pexels.com/photos/2251206/pexels-photo-2251206.jpeg?auto=compress&cs=tinysrgb&w=800',
    locationId: 1,
    approvalType: ApprovalTypes.Auto,
    restrictedCategoryIds: [12],
    isVisible: true,
  },
  isComplete: false,
  isStripeOnboardingComplete: true,
  organizationId: null,
}
